export const getRandomCrypto = (min: number, max: number) => {
  const randomArray = new Uint32Array(1);
  crypto.getRandomValues(randomArray);
  return min + (randomArray[0] / 0xffffffff) * (max - min);
};
